import React from "react";
import { Link } from "react-router-dom";
import { getFullYear } from "../utilities/Utilities";

const Footer: React.FC = () => {
    return (
        <div className="bg-brown text-white py-4 px-20">
            <div className="flex flex-col lg:flex-row mb-20">
                <div className="w-[70%]">
                    <h3 className="font-bold text-lg mb-10">TELE COURT</h3>
                </div>
                <div className="w-[30%] flex gap-10 text-sm">
                    <div className="flex flex-col gap-3">
                        <h4 className="font-bold">About</h4>
                        <Link to="">Company</Link>
                    </div>
                    <div className="flex flex-col gap-3">
                        <h4 className="font-bold">Socials</h4>
                        <Link to="">X{'(Twitter)'}</Link>
                        <Link to="">Instagram</Link>
                    </div>
                    <div className="flex flex-col gap-3">
                        <h4 className="font-bold">Support</h4>
                        <Link to="">FAQs</Link>
                        <Link to="">Email</Link>
                        <Link to="">Contact Us</Link>
                    </div>
                </div>
            </div>
            <div><p className="text-sm">copyrigtht&copy;{getFullYear()} thetechlawyered. All right reserved</p></div>
        </div>
    )
}

export default Footer